const extra = (t: any) => [
  {
    label: t('Recommendations'),
    description: t(
      'Get personalized recommendations for sessions to watch, based on your replay history and search preferences.',
    ),
    key: MODULES.RECOMMENDATIONS,
    icon: 'magic',
    hidden: true,
  },
]

export const enum MODULES {
  ASSIST = 'assist',
  HIGHLIGHTS = 'notes',
  BUG_REPORTS = 'bug-reports',
  OFFLINE_RECORDINGS = 'offline-recordings',
  ALERTS = 'alerts',
  ASSIST_STATS = 'assist-stats',
  FEATURE_FLAGS = 'feature-flags',
  RECOMMENDATIONS = 'recommendations',
  USABILITY_TESTS = 'usability-tests',
}

export default extra
